// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-upload-indicator-container {
  position: absolute;
  /*bottom: calc(var(--overlay-panel-padding) + var(--input-element-gap));*/ /*TODO: apply this bottom value again, when we reintroduce the bottom menu*/
  bottom: var(--dialog-element-gap);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  align-items: center;
  background-color: var(--dialog-background-color);
  padding: var(--input-element-gap-small)
    calc(var(--input-element-gap-small) * 2);
  border-radius: var(--dialog-border-radius);
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/model-upload-indicator/ModelUploadIndicator.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yEAAyE,EAAE,2EAA2E;EACtJ,iCAAiC;EACjC,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,gDAAgD;EAChD;4CAC0C;EAC1C,0CAA0C;AAC5C","sourcesContent":[".model-upload-indicator-container {\n  position: absolute;\n  /*bottom: calc(var(--overlay-panel-padding) + var(--input-element-gap));*/ /*TODO: apply this bottom value again, when we reintroduce the bottom menu*/\n  bottom: var(--dialog-element-gap);\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  align-items: center;\n  background-color: var(--dialog-background-color);\n  padding: var(--input-element-gap-small)\n    calc(var(--input-element-gap-small) * 2);\n  border-radius: var(--dialog-border-radius);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
